<div class="product-activity-dialog">
  <!-- Fixed Header -->
  <div class="dialog-header">
    <div class="header-content">
      <h2>{{ data.prdNameEn }}</h2>
      <span class="prd-code">{{ data.prdCode }}</span>
    </div>
    <button mat-icon-button class="close-button" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Scrollable Body -->
  <div class="dialog-body">
    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Empty State: storage-less products can still receive stock from here.
         The message names the actual situation - the product is not in a
         storage yet - instead of the vaguer "no activity found", which sent
         people looking for a problem that is not there. -->
    <div *ngIf="!isLoading && storages.length === 0" class="no-data">
      <p>{{ 'products.notInAnyStorageYet' | translate }}</p>
      <button mat-flat-button color="primary" (click)="openReceiveIntoStorage()">
        <mat-icon>move_to_inbox</mat-icon>
        <span>{{ 'form.receiving.addReceiving' | translate }}</span>
      </button>
    </div>

    <!-- Storage Cards with Accordion -->
    <div *ngIf="!isLoading && storages.length > 0" class="storage-cards">
      <div *ngFor="let storage of storages; trackBy: trackByStorageId" class="storage-card" [id]="'storage-' + storage.storageStructureID">
        <mat-accordion>
          <mat-expansion-panel [expanded]="isExpanded(storage.storageStructureID)"
                               (opened)="onPanelToggle(storage.storageStructureID, true)"
                               (closed)="onPanelToggle(storage.storageStructureID, false)">
            <mat-expansion-panel-header>
              <div class="storage-header">
                <div class="storage-info">
                  <mat-icon class="storage-icon">inventory_2</mat-icon>
                  <span class="storage-name">{{ storage.storagePath }}</span>
                </div>
                <div class="storage-metrics">
                  <div class="metric">
                    <span class="metric-label">{{ 'pickings.table.OnHand' | translate }}</span>
                    <span class="metric-value" [class.negative]="storage.onHand < 0">{{ storage.onHand }}</span>
                  </div>
                  <div class="metric">
                    <span class="metric-label">{{ 'productStockHistory.lastCount' | translate }}</span>
                    <span class="metric-value last-count">{{ storage.lastCount !== null ? storage.lastCount : '-' }}</span>
                  </div>
                </div>
              </div>
            </mat-expansion-panel-header>

            <!-- Panel Content -->
            <div class="panel-content">
              <div class="panel-actions">
                <button mat-flat-button class="pick-button"
                        (click)="openQuickPick(storage); $event.stopPropagation()">
                  {{ 'pick' | translate }}
                </button>
                <button mat-flat-button class="receive-button"
                        (click)="openQuickReceive(storage); $event.stopPropagation()">
                  {{ 'receive' | translate }}
                </button>
                <button mat-flat-button color="primary" (click)="openOverride(storage); $event.stopPropagation()">
                  {{ 'override' | translate }}
                </button>

                <!-- Print Button -->
                <div class="print-button-wrapper" [hidden]="data.locEnablePrinting == 0 && data.locEnableBrotherPrinting == 0">
                  <button mat-flat-button color="accent" [matMenuTriggerFor]="printMenu"
                          [disabled]="hasDymoPrinter == false && hasBrotherPrinter == false"
                          (click)="$event.stopPropagation()">
                    <mat-icon>print</mat-icon>
                    <span>{{ "printLabel" | translate }}</span>
                  </button>

                  <mat-menu #printMenu="matMenu" class="product-edit__labelMenu mat_menu">
                    <ng-container *ngFor="let group of printLabelList">
                      <ng-container *ngFor="let printer of group | keyvalue">
                        <div mat-submenu class="printerListTitle"
                             *ngIf="(printer.key === 'BROTHER (Windows only)' && data.locEnableBrotherPrinting == 1) || (printer.key === 'DYMO' && data.locEnablePrinting == 1)">
                          {{ printer.key }}
                        </div>
                        <ng-container *ngFor="let label of printer.value">
                          <button *ngIf="printer.key === 'DYMO' && data.locEnablePrinting == 1"
                                  mat-menu-item
                                  [attr.data-name]="label.name"
                                  [attr.data-value]="label.value"
                                  (click)="onSelectLabel($event, printer.key, label.value, storage.storageStructureID)">
                            {{ label.name }}
                          </button>
                          <button *ngIf="printer.key === 'BROTHER (Windows only)' && data.locEnableBrotherPrinting == 1"
                                  mat-menu-item
                                  [attr.data-name]="label.name"
                                  [attr.data-value]="label.value"
                                  [attr.data-storageStructureID]="storage.storageStructureID"
                                  [attr.data-StoragePrint]="false"
                                  [attr.data-PrdID]="data.prdID"
                                  [attr.data-prdCode]="data.prdCode"
                                  [attr.data-location]="storage.storagePath"
                                  [attr.data-path]="storage.storagePath"
                                  [attr.data-prdCasePack]="data.prdCasePack"
                                  [attr.data-prdNameEn]="data.prdNameEn"
                                  [attr.data-customFieldPrintable]="data.customFieldPrintable"
                                  [attr.data-prdCustomField1]="data.prdCustomField1"
                                  [attr.data-prdCustomField2]="data.prdCustomField2"
                                  [attr.data-template]="label.templateFile"
                                  onclick="DoPrint(this)">
                            {{ label.name }}
                          </button>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </mat-menu>
                </div>
              </div>

              <!-- Activity Table -->
              <div class="activity-table-wrapper" *ngIf="storage.activities && storage.activities.length > 0">
                <table class="activity-table">
                  <thead>
                    <tr>
                      <th>{{ 'time' | translate }}</th>
                      <th>{{ 'action' | translate }}</th>
                      <th>{{ 'user' | translate }}</th>
                      <th>{{ 'movement.note' | translate }}</th>
                      <th class="text-right">{{ 'quantity' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let activity of storage.activities">
                      <td class="time-cell">{{ activity.time }}</td>
                      <td>
                        <span class="action-badge" [ngClass]="getActionClass(activity.action)">
                          {{ activity.action }}
                        </span>
                      </td>
                      <td>{{ activity.user }}</td>
                      <td>
                        {{ activity.note || '-' }}
                        <app-serial-tags *ngIf="activity.action === 'Picked' || activity.action === 'Received'"
                                         [serials]="activity.serialNumbers"
                                         [serialized]="data.prdIsSerialized == 1"
                                         [kind]="activity.action === 'Received' ? 'receive' : 'pick'"
                                         [prdID]="data.prdID" (reportOpen)="onClose()"></app-serial-tags>
                      </td>
                      <td class="qty-cell text-right" [ngClass]="getQtyClass(activity.action)">
                        <ng-container [ngSwitch]="activity.action">
                          <span *ngSwitchCase="'Picked'">-{{ activity.quantity }}</span>
                          <span *ngSwitchCase="'Adjusted'">→ {{ activity.quantity }}</span>
                          <span *ngSwitchCase="'Counted'">{{ activity.quantity }}</span>
                          <span *ngSwitchDefault>+{{ activity.quantity }}</span>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- No Activities -->
              <div *ngIf="!storage.activities || storage.activities.length === 0" class="no-activities">
                {{ 'noActivities' | translate }}
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>

  <!-- DYMO Print Trigger -->
  <div id="dymoPrintSelected" style="display: none;" onclick="printSelected()"></div>
</div>
